export const setSelectedCartOrQuotes = (cartOrQuote) => {
  return async (dispatch) => {
    localStorage.setItem("selectedCartOrQuote", JSON.stringify(cartOrQuote));
    dispatch({ type: "GET_CART_OR_QUOTE", ...cartOrQuote });
  };
};
